import { render } from "./AddGroup.vue?vue&type=template&id=0b2d9eee&scoped=true"
import script from "./AddGroup.vue?vue&type=script&lang=js"
export * from "./AddGroup.vue?vue&type=script&lang=js"

import "./AddGroup.vue?vue&type=style&index=0&id=0b2d9eee&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2d9eee"]])

export default __exports__